import { p as proxyCustomElement, H, c as createEvent, h } from './p-d7c3b756.js';
import { isEqual, isEmpty } from 'lodash-es';
import { d as defineCustomElement$d } from './p-bcd74937.js';
import { d as defineCustomElement$c } from './p-8c4c95dc.js';
import { d as defineCustomElement$b } from './p-30186dbe.js';
import { d as defineCustomElement$a } from './p-1744d5db.js';
import { d as defineCustomElement$9 } from './p-6c17fe8d.js';
import { d as defineCustomElement$8 } from './p-75988d0a.js';
import { d as defineCustomElement$7 } from './p-8fb4ef78.js';
import { d as defineCustomElement$6 } from './p-17fd48bd.js';
import { d as defineCustomElement$5 } from './p-e02a2c19.js';
import { d as defineCustomElement$4 } from './p-4c1b8a2d.js';
import { d as defineCustomElement$3 } from './p-6a1cffde.js';
import { d as defineCustomElement$2 } from './p-cf5e3e4b.js';
import { u as uuidv4 } from './p-2b83a1d1.js';
import { r as valuesToString, B as BxfCalendarConstants } from './p-c40beb29.js';
import { l as createSelector } from './p-0856cfca.js';
import { R as Role } from './p-2c2985b9.js';

const bxfCalendarGroupCss = "button.sc-bxf-calendar-group:hover,a.sc-bxf-calendar-group:hover,input[type=radio].sc-bxf-calendar-group:hover,input[type=checkbox].sc-bxf-calendar-group:hover,input[type=radio].sc-bxf-calendar-group:checked:hover,input[type=checkbox].sc-bxf-calendar-group:checked:hover,svg.sc-bxf-calendar-group:hover{cursor:pointer}svg[disabled].sc-bxf-calendar-group:hover,button[disabled].sc-bxf-calendar-group:hover,label[disabled].sc-bxf-calendar-group:hover,input[type=checkbox].sc-bxf-calendar-group:disabled:hover,input[type=radio].sc-bxf-calendar-group:disabled:hover,input[type=checkbox].sc-bxf-calendar-group:checked:disabled:hover,input[type=radio].sc-bxf-calendar-group:checked:disabled:hover{cursor:default}.bxf__assistive-text--hidden.sc-bxf-calendar-group{position:absolute !important;left:-625rem;top:auto;width:0.0625rem;height:0.0625rem;overflow:hidden}.bxf-calendar__badge.sc-bxf-calendar-group,.bxf-calendar__badge--holiday.sc-bxf-calendar-group,.bxf-calendar__footer__badge--holiday.sc-bxf-calendar-group,.bxf-calendar__badge--markerA.sc-bxf-calendar-group,.bxf-calendar__footer__badge--markerA.sc-bxf-calendar-group,.bxf-calendar__badge--markerB.sc-bxf-calendar-group,.bxf-calendar__footer__badge--markerB.sc-bxf-calendar-group{margin:0.1875rem 0.0625rem 0 0.0625rem;padding:0;width:0.25rem;height:0.25rem;border:none;font-weight:bold}.bxf-calendar__badge--holiday.sc-bxf-calendar-group,.bxf-calendar__footer__badge--holiday.sc-bxf-calendar-group{border-radius:0.5rem;background-color:var(--calendar__background-color--holiday)}.bxf-calendar__footer__badge--holiday.sc-bxf-calendar-group{width:0.375rem;height:0.375rem;display:inline-flex}.bxf-calendar__badge--markerA.sc-bxf-calendar-group,.bxf-calendar__footer__badge--markerA.sc-bxf-calendar-group{transform:rotate(45deg);background-color:var(--calendar__background-color--markerA)}.bxf-calendar-group__container.sc-bxf-calendar-group{display:inline-grid}.bxf-calendar-group__container--space.sc-bxf-calendar-group{padding-right:1.5rem}.bxf-calendar__calendar--row.sc-bxf-calendar-group{display:table-caption}.bxf-calendar-group.sc-bxf-calendar-group{overflow:auto}.bxf-calendar__footer__badge--markerA.sc-bxf-calendar-group{width:0.34375rem;height:0.34375rem;display:inline-flex}.bxf-calendar__badge--markerB.sc-bxf-calendar-group,.bxf-calendar__footer__badge--markerB.sc-bxf-calendar-group{width:0rem;height:0rem;border-left:0.15625rem solid transparent;border-right:0.15625rem solid transparent;border-bottom:0.3125rem solid var(--calendar__background-color--markerB)}.bxf-calendar__footer__badge--markerB.sc-bxf-calendar-group{border-left:0.25rem solid transparent;border-right:0.25rem solid transparent;border-bottom:0.5rem solid var(--calendar__background-color--markerB);display:inline-flex}.bxf-calendar__key__container.sc-bxf-calendar-group{display:inline-flex;padding-bottom:0.25rem;justify-content:space-around}.bxf-calendar__key__container.sc-bxf-calendar-group:hover{cursor:pointer}.bxf-calendar__badge__label.sc-bxf-calendar-group{padding-top:0.1875rem;padding-right:0.25rem;padding-left:0.25rem;color:var(--primary-text__color);font-size:var(--font-size);display:inline-flex}.bxf-calendar__badge__positioning.sc-bxf-calendar-group{display:inline-flex}.bxf-calendar__footer.sc-bxf-calendar-group{height:1.5rem;display:flex;justify-content:space-between}.bxf-calendar__footer--selected.sc-bxf-calendar-group{color:var(--primary-action__color)}.bxf-calendar__footer--right.sc-bxf-calendar-group{display:flex;width:100%;justify-content:right}.bxf-calendar__footer--label.sc-bxf-calendar-group{display:flex;font-size:var(--font-size);padding-top:0.25rem;padding-right:0.5rem;color:var(--secondary-text__color)}.bxf-calendar__footer--select.sc-bxf-calendar-group{width:7.5rem}.bxf-calendar__footer--settings.sc-bxf-calendar-group{display:flex}.bxf-calendar__footer--settings.sc-bxf-calendar-group bxf-button.sc-bxf-calendar-group{line-height:2rem}@media (forced-colors: active){.bxf-calendar__badge--holiday.sc-bxf-calendar-group,.bxf-calendar__footer__badge--holiday.sc-bxf-calendar-group,.bxf-calendar__badge--markerA.sc-bxf-calendar-group,.bxf-calendar__footer__badge--markerA.sc-bxf-calendar-group,.bxf-calendar__badge--markerB.sc-bxf-calendar-group,.bxf-calendar__footer__badge--markerB.sc-bxf-calendar-group{background-color:CanvasText}}";
const BxfCalendarGroupStyle0 = bxfCalendarGroupCss;

const { LABEL, HOLIDAYS_LABEL, KEY_CONTAINER, KEY_ITEM, FOOTER_SELECT, HOLIDAY_FOOTER_BADGE, MARKER_A_FOOTER_BADGE, FOOTER_RIGHT, CALENDAR_GROUP_CONTAINER, CALENDAR_GROUP, BADGE_POSITIONING, MARKER_B_FOOTER_BADGE, SECONDARY_TEXT_COLOR, CALENDAR_ROW, CALENDAR_CONTAINER_SPACE, FOOTER_BADGE_LABEL, } = BxfCalendarConstants.STRING;
const BxfCalendarGroup$1 = /*@__PURE__*/ proxyCustomElement(class BxfCalendarGroup extends H {
    get host() { return this; }
    // #endregion "Props"
    /**
     * This event is emitted when a calendar is selected in settings panel
     */
    calendarSelected;
    /**
     * This event is emitted when a calendar is selected in settings panel
     */
    selectedDatesChanged;
    keyDisplayChanged;
    selectionChangedHandler(event) {
        this.calendarSelectionHandler(event);
    }
    keyDisplayChangedHandler(event) {
        const bxfId = event.detail?.value;
        /* istanbul ignore else */
        if (bxfId === this.HOLIDAY_BXF_ID) {
            this.holidayEnabled =
                this.holidayEnabled === '' ? this._secondaryTextColor : '';
        }
        else if (bxfId === this.MARKER_A_BXF_ID) {
            this.markerAEnabled =
                this.markerAEnabled === '' ? this._secondaryTextColor : '';
        }
        else if (bxfId === this.MARKER_B_BXF_ID) {
            this.markerBEnabled =
                this.markerBEnabled === '' ? this._secondaryTextColor : '';
        }
    }
    dataChangeHandler() {
        if (this.data) {
            this._data = this.splitToRows();
        }
    }
    /**
     * Update activeCalendar state when settingsSelectData dynamically changed
     */
    settingsSelectDataChangeHandler(newValue, oldValue) {
        if (!isEqual(newValue, oldValue)) {
            this.updateActiveCalendar(newValue);
        }
    }
    HOLIDAY_BXF_ID = uuidv4();
    MARKER_A_BXF_ID = uuidv4();
    MARKER_B_BXF_ID = uuidv4();
    _labelId = uuidv4();
    _secondaryTextColor = SECONDARY_TEXT_COLOR;
    componentWillLoad() {
        this._data = this.splitToRows();
        this.valStrArr = valuesToString(this.values);
        this.maxSelected = this.values.length >= this.maxDaysSelectable;
        this.updateActiveCalendar(this.settingsSelectData);
    }
    constructor() {
        super();
        this.__registerHost();
        this.calendarSelected = createEvent(this, "calendarSelected", 7);
        this.selectedDatesChanged = createEvent(this, "selectedDatesChanged", 7);
        this.keyDisplayChanged = createEvent(this, "keyDisplayChanged", 7);
        this.label = '';
        this.data = [];
        this.values = [];
        this.settingsSelectData = [];
        this.hideInactiveDateDetails = true;
        this.selectLabel = 'Default, US';
        this.keepMouseFocus = false;
        this.parentOverlayContainerSelector = 'body';
        this.dataTestSuffix = undefined;
        this.calendarsPerRow = 3;
        this.disableWeekends = false;
        this.showMarkerKey = true;
        this.showMarkerPopovers = true;
        this.holidays = {};
        this.customDateMarkerA = {};
        this.customDateMarkerB = {};
        this.maxDaysSelectable = 1;
        this.isTodayHighlighted = true;
        this.isTracking = true;
        this.eventData = {};
        this.trackingData = undefined;
        this.assistiveText = '';
        this.disabledDates = [];
        this.hideDatesOutsideActiveMonth = false;
        this.activeCalendar = undefined;
        this.maxSelected = false;
        this._data = [];
        this.valStrArr = undefined;
        this.holidayEnabled = '';
        this.markerAEnabled = '';
        this.markerBEnabled = '';
        this.calendarValuesChangeHandler =
            this.calendarValuesChangeHandler.bind(this);
    }
    /**
     * Update activeCalendar state based on settingsSelectData
     */
    updateActiveCalendar(settingsSelectData) {
        if (settingsSelectData?.length) {
            const index = settingsSelectData.findIndex((data) => data.isSelected);
            this.activeCalendar = settingsSelectData[index].value.calendar;
        }
    }
    valuesToObject(values) {
        const newVal = [...values];
        return newVal.map((value) => {
            const valArr = value.split('-');
            return { day: +valArr[0], month: +valArr[1], year: +valArr[2] };
        });
    }
    calendarValuesChangeHandler(event) {
        const { value } = event.detail;
        if (this.maxDaysSelectable === 1) {
            this.valStrArr = [value];
        }
        else if (!event.detail.isSelected) {
            this.valStrArr = this.valStrArr.filter((item) => item !== value);
        }
        else if (!this.valStrArr.includes(value)) {
            this.valStrArr.push(value);
        }
        this.values = [...this.valuesToObject(this.valStrArr)];
        this.selectedDatesChanged.emit({
            values: this.valStrArr,
            eventData: this.eventData,
        });
    }
    splitToRows() {
        const array = [...this.data];
        const result = [];
        while (array.length > this.calendarsPerRow) {
            result.push(array.splice(0, this.calendarsPerRow));
        }
        result.push(array);
        return result;
    }
    renderRow(rowData) {
        return rowData?.map((calendar, index) => {
            const dataTestSuffix = index + 1 < 10 ? `0${index + 1}` : `${index + 1}`;
            return (h("div", { key: dataTestSuffix, class: CALENDAR_CONTAINER_SPACE }, h("bxf-calendar", { initActiveMonth: calendar.month, holidays: this.holidays, dataTestSuffix: createSelector(`${dataTestSuffix}`, this.dataTestSuffix, true), customDateMarkerA: this.customDateMarkerA, customDateMarkerB: this.customDateMarkerB, maxDaysSelectable: this.maxDaysSelectable, hasMarkerKey: false, hideDatesOutsideActiveMonth: this.hideDatesOutsideActiveMonth, disableWeekends: this.disableWeekends || calendar.disableWeekends, initActiveYear: calendar.year, disabledDates: this.disabledDates, hideInactiveDateDetails: this.hideInactiveDateDetails, isHeaderDynamic: false, isFooterDisabled: true, isDialog: false, footerLabel: '', isTodayHighlighted: this.isTodayHighlighted, isCalendarVisible: true, hasTodayInFooter: false, eventData: this.eventData, showMarkerPopovers: this.showMarkerPopovers, values: this.values, onCalendarValueChanged: this.calendarValuesChangeHandler, parentOverlayContainerSelector: this.parentOverlayContainerSelector })));
        });
    }
    renderKeyItems(type) {
        const { event } = type;
        if (event && Object.keys(event).length) {
            return (h("span", { "data-bxf-id": type.id, onClick: (e) => this.keyDisplayChanged.emit({
                    eventData: this.eventData,
                    srcEvent: e,
                    value: type.id,
                }), class: KEY_ITEM }, h("span", { class: type.markerType, style: type.markerType === MARKER_B_FOOTER_BADGE
                    ? { borderBottomColor: type.ref }
                    : {
                        backgroundColor: type.ref,
                    } }), h("span", { class: FOOTER_BADGE_LABEL, style: {
                    color: type.ref,
                } }, type.label)));
        }
        return null;
    }
    renderMarkerKey() {
        const hasEvents = !(isEmpty(this.holidays) &&
            isEmpty(this.customDateMarkerA) &&
            isEmpty(this.customDateMarkerB));
        if (hasEvents) {
            const classTypes = [
                {
                    markerType: HOLIDAY_FOOTER_BADGE,
                    label: HOLIDAYS_LABEL,
                    event: this.holidays,
                    id: this.HOLIDAY_BXF_ID,
                    ref: this.holidayEnabled,
                },
                {
                    markerType: MARKER_A_FOOTER_BADGE,
                    label: this.customDateMarkerA?.markerLabel,
                    event: this.customDateMarkerA?.events,
                    id: this.MARKER_A_BXF_ID,
                    ref: this.markerAEnabled,
                },
                {
                    markerType: MARKER_B_FOOTER_BADGE,
                    label: this.customDateMarkerB?.markerLabel,
                    event: this.customDateMarkerB?.events,
                    id: this.MARKER_B_BXF_ID,
                    ref: this.markerBEnabled,
                },
            ];
            return (h("div", { class: KEY_CONTAINER }, classTypes.map((type) => this.renderKeyItems(type))));
        }
        return null;
    }
    calendarSelectionHandler(event = {}) {
        const { detail: { value: { value } } = { value: { value: {} } } } = event;
        if (value.calendar && value.calendar !== this.activeCalendar) {
            this.activeCalendar = value.calendar;
            this.calendarSelected.emit({
                value,
                eventData: this.eventData,
                srcEvent: event,
            });
        }
    }
    renderLabelInFooter() {
        /* istanbul ignore else */
        if (this.selectLabel) {
            return h("span", { class: LABEL }, this.selectLabel);
        }
        return null;
    }
    renderSelection() {
        return (h("div", { class: FOOTER_RIGHT }, this.renderLabelInFooter(), h("bxf-select", { keepMouseFocus: this.keepMouseFocus, hasInitialOptionPlaceholder: false, shouldCloseOverlays: false, "data-test": createSelector(this.host.tagName, this.label), class: FOOTER_SELECT, size: 'small', parentOverlayContainerSelector: this.parentOverlayContainerSelector, dataTestSuffix: createSelector('00', this.dataTestSuffix, true), data: [
                {
                    values: this.settingsSelectData,
                },
            ] })));
    }
    renderContent() {
        return this._data?.map((rowData, index) => {
            const key = index + 1 < 10 ? `0${index + 1}` : `${index + 1}`;
            return (h("div", { key: key, class: BADGE_POSITIONING }, this.renderRow(rowData)));
        });
    }
    render() {
        return (h("div", { key: '025c81b2490bd1d8b743cbe3cd1272f80e408b29', class: CALENDAR_GROUP_CONTAINER }, this.settingsSelectData.length ? this.renderSelection() : null, h("div", { key: '3d5610a03d6c104d1d391eb151b1c29456c57c28', class: CALENDAR_GROUP }, h("div", { key: 'cf7d75938e07a6d2bba3ee1698f6b28cf4a64f9a', class: CALENDAR_ROW }, h("br", { key: '69fda9feed5c005ae70f709c8f14d5bc65cefcdf' }), h("div", { key: '95493756f7b0f8c83ecaf0ca7517bc48db482cdb', role: Role.GROUP, "aria-labelledby": this.label ? this._labelId : null, "aria-label": this.label ? null : this.assistiveText }, this.renderContent()))), this.showMarkerKey ? this.renderMarkerKey() : null));
    }
    static get watchers() { return {
        "data": ["dataChangeHandler"],
        "settingsSelectData": ["settingsSelectDataChangeHandler"]
    }; }
    static get style() { return BxfCalendarGroupStyle0; }
}, [2, "bxf-calendar-group", {
        "label": [513],
        "data": [1040],
        "values": [1040],
        "settingsSelectData": [16],
        "hideInactiveDateDetails": [1540, "hide-inactive-date-details"],
        "selectLabel": [1537, "select-label"],
        "keepMouseFocus": [516, "keep-mouse-focus"],
        "parentOverlayContainerSelector": [513, "parent-overlay-container-selector"],
        "dataTestSuffix": [520, "data-test-suffix"],
        "calendarsPerRow": [514, "calendars-per-row"],
        "disableWeekends": [516, "disable-weekends"],
        "showMarkerKey": [516, "show-marker-key"],
        "showMarkerPopovers": [1540, "show-marker-popovers"],
        "holidays": [16],
        "customDateMarkerA": [16],
        "customDateMarkerB": [16],
        "maxDaysSelectable": [1538, "max-days-selectable"],
        "isTodayHighlighted": [1540, "is-today-highlighted"],
        "isTracking": [516, "is-tracking"],
        "eventData": [16],
        "trackingData": [16],
        "assistiveText": [1, "assistive-text"],
        "disabledDates": [16],
        "hideDatesOutsideActiveMonth": [516, "hide-dates-outside-active-month"],
        "activeCalendar": [32],
        "maxSelected": [32],
        "_data": [32],
        "valStrArr": [32],
        "holidayEnabled": [32],
        "markerAEnabled": [32],
        "markerBEnabled": [32]
    }, [[0, "selectionChanged", "selectionChangedHandler"], [0, "keyDisplayChanged", "keyDisplayChangedHandler"]], {
        "data": ["dataChangeHandler"],
        "settingsSelectData": ["settingsSelectDataChangeHandler"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bxf-calendar-group", "bxf-badge", "bxf-button", "bxf-calendar", "bxf-calendar-settings", "bxf-icon", "bxf-inline-menu", "bxf-link", "bxf-popover", "bxf-radio", "bxf-radio-group", "bxf-select", "bxf-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "bxf-calendar-group":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BxfCalendarGroup$1);
            }
            break;
        case "bxf-badge":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "bxf-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "bxf-calendar":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "bxf-calendar-settings":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "bxf-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "bxf-inline-menu":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "bxf-link":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "bxf-popover":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "bxf-radio":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "bxf-radio-group":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "bxf-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "bxf-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const BxfCalendarGroup = BxfCalendarGroup$1;
const defineCustomElement = defineCustomElement$1;

export { BxfCalendarGroup, defineCustomElement };
